import React, { useState } from "react";
import SaveButton from "../../../components/Buttons/SaveButton";
import FileUploadField from "../../../components/Fields/FileUploadField";
import { FormConfig } from "../../../components/Fields/Types";
import useValidation from "../../../components/Hooks/ValidationHook/useValidation";
import Popup from "../../../components/Popups/Popup";
import SpinnerOverlay from "../../../components/Spinner/SpinnerOverlay";
import { useNotifications } from "../../../contexts/notificationContext";
import FileCreateResultModel from "../../../models/FileCreateResultModel";
import DataService from "../../../services/data.service";
import { PopupProps } from "../../../types/PopupProps";
import { DataResult, Result } from "../../../types/Result";

interface IProps extends PopupProps {
    itemRevisionId: number
}

interface ChangeItemImageModel {
    itemRevisionId: number,
    fileName?: string
    file?: File
    fileResult?: FileCreateResultModel
}

const ChangeItemImagePopup: React.FC<IProps> = ({ show, onHide, itemRevisionId }) => {
    const [serverErrors, setServerErrors] = useState<Result>({ isSuccesful: true, messages: [] });
    const [file, setFile] = useState<File>();
    const [showSpinner, setShowSpinner] = useState(false);
    const { handleResult, handleException } = useNotifications();

    const [formData, setFormData] = useState<ChangeItemImageModel>({
        itemRevisionId: itemRevisionId,
    });

    function submit() {
        if (formData && file) {
            setShowSpinner(true)
            DataService.createFile(file)
                .then(fileResponse => {
                    if (fileResponse.isSuccesful === true && fileResponse.data) {
                        formData.fileResult = fileResponse.data;
                        formData.fileName = file.name;
                        DataService
                            .post<DataResult<number>>(`api/v1/ItemRevisions/${itemRevisionId}/ChangeItemImage`, formData)
                            .then(response => {
                                setShowSpinner(false)
                                handleResult(response);
                                setServerErrors(response);
                                if (response.isSuccesful === true) {
                                    onHide();
                                }
                            })
                            .catch(e => { setShowSpinner(false);  handleException(e) });
                    }
                    else {
                        setShowSpinner(false)
                        handleResult(fileResponse)
                        setServerErrors(fileResponse);
                    }
                })
                .catch(e => { setShowSpinner(false); handleException(e) });
        }
    }

    function onFieldChanged(name: string, value: string | File): void {
        if (name === 'fileName' && typeof (value) === 'object') {
            setFile(value);
        }
        else {
            formData[name] = value;
        }
        setFormData(formData);
    }

    const formConfig: FormConfig = {
        fields: [
            { name: 'fileName', label: 'File', labelSize: 3 },
        ],
        handleSubmit: submit,
        handleFieldChanged: onFieldChanged,
        showErrors: 'always',
    };

    const { getFieldProps, getSubmitButtonProps } = useValidation(formConfig, formData, serverErrors);

    return (
        <>
            <Popup show={show} onHide={onHide} size={'lg'} title={'Change Item Image'} >
                <Popup.Body>
                    <FileUploadField {...getFieldProps('fileName')} multiple={false} />
                </Popup.Body>
                <Popup.Footer>
                    <SaveButton {...getSubmitButtonProps()} text='Change' />
                </Popup.Footer>
            </Popup>
            {showSpinner && <SpinnerOverlay />}
        </>
    );
}
export default ChangeItemImagePopup;